import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  TabContent, TabPane, Nav, NavItem, NavLink, Row, Col, Button, FormGroup, Label, Input, Alert,
  Modal, ModalHeader, ModalBody, ModalFooter, InputGroup, InputGroupAddon, InputGroupText,
} from "reactstrap";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
//import { API } from "aws-amplify";
import "../estilos.css";
import {
  updateRecibaSeriales,
  updatePProduccion,
  updateUbicacion,
  createUbicacion,
  updateLocacion,
  updatePProduccionGeneral,
  createPProduccionGeneral,
  updatePProduccionUltimoNumero,
  createPProduccionUltimoNumero,
  updatePlaneacionUltimoNumero,
  createPlaneacionUltimoNumero,
  createPlaneacion,
  createPProduccion,
  updateRecibaSerialesMP,
  createPlaneacionGeneral,
  updatePlaneacionGeneral,
} from "../../graphql/mutations";
import { clicPintado, guardarCargaPintado, manageResumenOperacion } from '../queries/Mutations';
import * as IoIcons from "react-icons/io";
import Moment, { updateLocale } from "moment";
import QrReader from "react-qr-reader";
import BarcodeReader from "react-barcode-reader";
import {
  GetPProduccion,
  GetUbicacion,
  GetLocaciones,
  GetRecibaSerialesID,
  GetPProduccionID,
  GetPProduccionGeneral,
  GetPProduccionGeneralID,
  GetRecibaSeriales,
  GetProductosID,
  GetPlaneacion,
  GetRecibaSerialesMP,
  GetPlaneacionGeneral,
  GetPlaneacionGeneralID,
} from "../queries/Queries";
import { FaPlusSquare } from "react-icons/fa";
import { listPProduccionUltimoNumeros, listPlaneacionUltimoNumeros } from "../../graphql/queries";
import { cambioUbicacionSeriales, combinarIDS, ObtenerSerialesPProduccionPS } from "../queries/DCUbicaciones";
import usePProduccion from "../../hooks/usePProduccion";
import { onUpdateRecibaSerialesMP } from "../../graphql/subscriptions";
import DetallesProduccion from "./DetallesProduccion";
import Pintado from "./Pintado";
import Notificar from "../navbar/Notificar";
import GeneralProduccion from "./GeneralProduccion";
import { generateClient } from "aws-amplify/api";

const API = generateClient();

const initialfFormState = { formType: "Producción" };

function Produccion() {
  //Declaración de variables
  const [pProduccionPEyP, setPProduccionPEyP] = useState([]);
  const [pProduccionPEyPSinfiltro, setPProduccionPEyPSinfiltro] = useState([]);
  const [mensajeAlert, setMensajeAlert] = useState("No fue posible realizar la operación, error indeterminado: revise su conexión a internet, recargue la página y vuelva a intentarlo, si el error persiste, favor de comunicarse a sistemas");
  const [color, setColor] = useState("warning");
  const [para, setPara] = useState("");
  const [registroNuevoPP, setRegistroNuevoPP] = useState({});
  const [recibaOriginal, setRecibaOriginal] = useState({});
  const userName = window.$name;
  const ppproduccion = window.$Produccion ? window.$Produccion : false;
  const ppcargaManual = window.$ProduccionCargaManual ? window.$ProduccionCargaManual : false;
  const [sporNPU, setSporNPU] = useState(false);
  const [recibaSNP, setRecibaSNP] = useState([]);
  const [detallesCarga, setDetallesCarga] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [aVisible, setAVisible] = useState(false);
  const [habilitado, setHabilitado] = useState(true);
  const [sumProduccionp, setSumProduccionp] = useState("");
  const [filtroVer, setFiltroVer] = useState("Todo");
  const onDismiss = () => setAVisible(false);
  const [modal3, setModal3] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [modal, setModal] = useState(false);
  const [indexCarga, setIndexCarga] = useState(0);
  const [textBCarga, setTextBCarga] = useState("Carga");
  const [vistaDetallesCarga, setVistaDetallesCarga] = useState(false);
  const [maximoNumeroCarga, setMaximoNumeroCarga] = useState(0);
  const [espaciosVacios, setEspaciosVacios] = useState(0);
  const [numeroPProduccion, setNumeroPProduccion] = useState(0);
  const [idProduccionGeneral, setIDProduccionGeneral] = useState("");
  const [pCSerialBTI, setPCSerialBTI] = useState("");
  const [verPProduccionSiguiente, setVerPProduccionSiguiente] = useState(false);
  const [cargandoSinQR, setCargandoSinQR] = useState(false);
  const [verPPSiguiente, setVerPPSiguiente] = useState(false);
  const [cargaCHKS, setCargaCHKS] = useState(false);
  const [cargaCompleta, setCargaCompleta] = useState(false);
  //const [dataResult, setDataResult] = useState(false);
  const [fechaPlaneacion, setFechaPlaneacion] = useState(
    Moment(new Date()).format("YYYY-MM-DD")
  );
  Moment.locale("en");
  var now = new Date();

  function handleError(err) {
    console.error(err);
  }

  function handleScan(data) {
    //data = data.replace('\'', '-')
    setSporNPU(false);
    if (data) {
      const serialID = data.replaceAll("'", "-");
      const datosProduccion = pProduccionPEyP.filter((planProduccion) => (planProduccion.recibaSerialID === serialID) || (planProduccion.serialRecibaBTI === serialID.toUpperCase()) || (planProduccion.serial === serialID.toUpperCase()));
      if (datosProduccion.length) {
        if (datosProduccion[0].piezasenPintado === datosProduccion[0].cantidadPiezas) {
          //setTextBCarga("Carga");
          window.scrollTo(0, 0);
          /*setMensajeAlert(
            "No fue posible realizar la operación: el material ya pasó a pintado."
          );
          setColor("warning");
          setCargando(false);
          setAVisible(true);*/
          setIndexCarga(0);
          preCarga("Serial", serialID);

        } else {
          if (datosProduccion[0].piezasenCargaDisponibles > 0) {
            setCargando(false);
            setAVisible(false);
            setPara("");
            setIndexCarga(datosProduccion[0].indexCarga);
            setTextBCarga("Carga");
            datosProduccion[0].piezasenCargando =
              datosProduccion[0].piezasenCargaDisponibles;
            if (cargaCompleta === false) {
              setModal2(!modal2);
              const nextSibling = document.querySelector(`input[id=numeroRackCargamm]`);
              if (nextSibling !== null) {
                nextSibling.focus();
              }
            } else {
              aceptarCargar(datosProduccion[0].indexCarga);
            }
          } else {
            //setTextBCarga("Carga");
            window.scrollTo(0, 0);
            /*setMensajeAlert(
              "No fue posible realizar la operación: ya no hay material disponible para cargar del registro seleccionado"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);*/
            setIndexCarga(0);
            preCarga("Serial", serialID);
          }
        }
      } else {

        setTextBCarga("Carga");
        window.scrollTo(0, 0);
        /*setMensajeAlert(
          "No fue posible realizar la operación: el código QR no coincide con ningún número de serie registrado para el plan de producción del día, favor de buscar el material que corresponda y volver a intentarlo"
        );
        setColor("warning");
        setCargando(false);
        setAVisible(true);*/
        setIndexCarga(0);
        preCarga("Serial", serialID);
      }
    }
    return <p>{data}</p>;
  }

  async function handlePintado(childData) {
    if (childData.completo === true) {
      setIDProduccionGeneral(childData.pproduccionGID);
    }
    window.scrollTo(0, 0);
    setColor(childData.color);
    setMensajeAlert(childData.mensaje);
    setAVisible(true);
    recargarPagina();

  };
  async function notificacionCreada(childData) {
    if (childData.completo === true) {
      setPara("");
      setColor("info");
      setMensajeAlert("Notificación enviada");
      setAVisible(true);
    }
    window.scrollTo(0, 0);
  };
  const toggle3 = () => setModal3(!modal3);
  const toggle2 = () => setModal2(!modal2);
  const toggle = () => setModal(!modal);
  //Método useEffect
  useEffect(() => {
    fetchPProduccionGeneral(fechaPlaneacion);
    //subscriptions();
  }, []);

  //Función que crea las subscripciones
  function subscriptions() {
    //se suscriben para los cambios en planeación base
    const variables = {
      filter: {
        // filtro en base a la fecha de pintado.
        or: [{
          pintadoFechaHora: {
            contains: Moment(new Date()).format("YYYY-MM-DD"),
          }
        },
        {
          cargaFechaHora: {
            contains: Moment(new Date()).format("YYYY-MM-DD"),
          },
        }
        ]
      }
    };

    //Subscripciones de la planeación base
    API.graphql({ query: onUpdateRecibaSerialesMP, variables }).subscribe({
      next: ({ provider, value }) => fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer),//fetchPlanProduccionPEyP("", filtroVer), //value.data.onUpdatePlaneacionBase
      error: (error) => console.warn(error)
    });

  }
  function nuevoDato(dato, datosf) {
    datosf = datosf.filter(spproduccion => spproduccion.id != dato.id);
    datosf.push(dato);
    busquedaPProduccion(datosf, filtroVer);
    //suscripciones.unsubscribe();
    //setMensajeAlert("Operación exitosa");
    //suscripciones(pProduccionPEyPSinfiltro);

    //setPProduccionPEyP(pProduccionPEyP);
  }
  //busqueda con el filtro ver Todo, No cargados, No pintados, No atrasados, Cargados, Pintados, Atrasados
  async function busquedaPProduccion(pproduccionsf, verBusqueda) {
    //Se filtran los datos del plan de producción por cliente, número de parte y serial.
    pproduccionsf = await pproduccionsf.filter(pproduccion =>
      (pproduccion.cantidadPlaneada ? pproduccion.cantidadPlaneada : 0) > 0 &&
      (pproduccion.piezasEnPlanta ? pproduccion.piezasEnPlanta : true) === true &&
      ((pproduccion.cantidadPlaneada ? pproduccion.cantidadPlaneada : 0) >
        (pproduccion.piezasenPintado ? pproduccion.piezasenPintado : 0) ||
        ((pproduccion.cantidadPlaneada ? pproduccion.cantidadPlaneada : 0)
          === (pproduccion.piezasenPintado ? pproduccion.piezasenPintado : 0) &&
          (pproduccion.pintadoFechaHora ? pproduccion.pintadoFechaHora : "").includes(Moment(new Date()).format("YYYY-MM-DD")))
      )).sort((a, b) =>
        (a.cliente + a.numerodeParte + a.serial) > (b.cliente + b.numerodeParte + b.serial) ? 1 :
          (a.cliente + a.numerodeParte + a.serial) < (b.cliente + b.numerodeParte + b.serial) ? -1 : 0);
    setPProduccionPEyPSinfiltro(pproduccionsf);
    //setMensajeAlert("Operación exitosa");
    //suscripciones(pproduccionsf);
    pproduccionsf = await pproduccionsf.filter(pproduccion => verBusqueda ?
      verBusqueda === "No cargados" ? ((!pproduccion.piezasenCarga ? 0 :
        pproduccion.piezasenCarga) + (!pproduccion.piezasenPintado ? 0 : pproduccion.piezasenPintado)) < pproduccion.cantidadPlaneada :
        verBusqueda === "No pintados" ? (!pproduccion.piezasenPintado ? 0 : pproduccion.piezasenPintado) < pproduccion.cantidadPlaneada :
          verBusqueda === "No atrasados" ? (pproduccion.cargaFechaHora ? pproduccion.cargaFechaHora : "").includes(Moment(new Date()).format("YYYY-MM-DD")) :
            verBusqueda === "Cargados" ? pproduccion.piezasenCarga :
              verBusqueda === "Pintados" ? pproduccion.piezasenPintado :
                verBusqueda === "Atrasados" ? !(pproduccion.cargaFechaHora ? pproduccion.cargaFechaHora : "").includes(Moment(new Date()).format("YYYY-MM-DD")) :
                  verBusqueda === "NSB" ? pCSerialBTI === "" ? pproduccion.id === pproduccion.id :
                    (pproduccion.serial.toLowerCase().includes(pCSerialBTI.toLowerCase()) ||
                      pproduccion.serialRecibaBTI.toLowerCase().includes(pCSerialBTI.toLowerCase()) ||
                      pproduccion.numerodeParte.toLowerCase().includes(pCSerialBTI.toLowerCase())) :
                    pproduccion.id === pproduccion.id //Todo
      : pproduccion.id === pproduccion.id);

    //Se obtine el número de carga
    var MNumeroCarga = 0;
    await Promise.all(
      pproduccionsf.map(async (pproduccion, i) => {
        //const piezasxRack = parseFloat(pproduccion.cantidadPlaneada) / parseFloat(pproduccion.racks);
        pproduccion.indexCarga = i;
        pproduccion.piezasenCargaDisponibles =
          parseInt(
            pproduccion.cantidadPlaneada ? pproduccion.cantidadPlaneada : 0
          ) -
          (parseInt(pproduccion.piezasenCarga ? pproduccion.piezasenCarga : 0));
        pproduccion.rackCarga = pproduccion.piezasenCargaDisponibles === pproduccion.cantidadPlaneada ?
          pproduccion.racks : (parseFloat(pproduccion.piezasenCargaDisponibles) / parseFloat(pproduccion.piezasXRack)).toFixed(2);
        //Se obtiene el máximo número de carga
        if (pproduccion.numeroCarga > MNumeroCarga)
          MNumeroCarga = pproduccion.numeroCarga;

        pproduccion.cicloCarga = pproduccion.numeroCarga
          ? pproduccion.numeroCarga + 1
          : 1;
        return pproduccion;
      })
    );

    setMaximoNumeroCarga(MNumeroCarga);
    setPProduccionPEyP(pproduccionsf);
  }

  async function recargarPagina() {
    setCargando(true);
    await fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
    setCargando(false);
  }
  //Obtiene los datos guardados de los planes de producción para carga y pintado
  async function fetchPlanProduccionPEyP(pproduccionG, filtroVerPP) {
    //Se obtienen datos de fecha y hora.
    //subscriptions();
    setFechaPlaneacion(Moment(new Date()).format("YYYY-MM-DD"));
    const hoy = new Date();
    const dia = hoy.getDay();
    const hora = Moment(hoy).format("HH:mm");
    if (dia < 5 && dia > 0 && hora > "14:59") {
      setVerPPSiguiente(true);
    } else {
      setVerPPSiguiente(false);
    }
    //Filtro por plan de producción activo
    setHabilitado(true);
    //7Se obtienen los datos del plan de producción
    const pproduccionGR = pproduccionG != "" ? await GetPProduccionGeneralID(pproduccionG) : {};
    const serialesPPG = await ObtenerSerialesPProduccionPS(pproduccionGR.id ? pproduccionGR : {});

    if (serialesPPG.length > 0) {
      await busquedaPProduccion(serialesPPG, filtroVerPP);
    } else {
      setPProduccionPEyP([]);

    }
  }
  async function fetchPProduccionGeneral(fecha) {
    setCargando(true);
    let filter = {
      and: [
        {
          activo: {
            eq: true,
          },
        },
        {
          fechaDePlaneacion: {
            eq: fecha,
          },
        },
      ],
    };
    //setNumeroPProduccion(numero);
    const PProduccionGeneral = await GetPProduccionGeneral(filter);
    if (PProduccionGeneral.length > 0) {
      await fetchPlanProduccionPEyP(PProduccionGeneral[0].id, filtroVer);
      setIDProduccionGeneral(PProduccionGeneral[0].id);
      setEspaciosVacios(PProduccionGeneral[0].espacioVacio);
    } else {
      await fetchPlanProduccionPEyP("", filtroVer);
      setIDProduccionGeneral("");
      setEspaciosVacios(0);
    }
    setCargando(false);
  }
  async function fecthReciba(datoTipo, dato) {
    var recibaData = {};
    var filter = {};
    const datoE = dato.substr(0, 2).toLowerCase() === "3s" ? dato.substr(2, dato.length) : dato;
    setPCSerialBTI(datoE);
    if (datoTipo === "Serial" || datoTipo === "NumeroParte") {
      if (datoTipo === "Serial") {
        filter = {
          and: [
            {
              or: [{
                serialRecibaBTI: {
                  eq: dato.toUpperCase(),
                }
              },
              {
                serial: {
                  eq: datoE,
                },
              }, {
                serial: {
                  eq: dato,
                },
              }, {
                recibaSerialID: {
                  eq: dato,
                }
              },
              ]
            },
            {
              activo: {
                eq: true,
              },
            },
            {
              piezasEnPlanta: {
                eq: true,
              },
            },
            {
              piezasenAlmacen: {
                gt: 0,
              },
            },
          ],
        };
      };
      if (datoTipo === "NumeroParte") {
        filter = {
          and: [
            {
              krecibaNP: {
                eq: dato.toUpperCase(),
              }
            },
            {
              activo: {
                eq: true,
              },
            },
            {
              piezasEnPlanta: {
                eq: true,
              },
            },
            {
              piezasenAlmacen: {
                gt: 0,
              },
            },
          ],
        };
      };
      const datosSerialMP = await GetRecibaSerialesMP(filter);
      var datosSerial = [];
      if (datosSerialMP.length) {
        await Promise.all(
          datosSerialMP.map((serialMp) => {
            serialMp.recibaSerialMPID = serialMp.id;
            serialMp.id = serialMp.recibaSerialID;
            serialMp.updatedAt = serialMp.rsUpdatedAt;
            delete serialMp.rsUpdatedAt;
            delete serialMp.recibaSerialID;
            return serialMp;
          }));
        datosSerial = datosSerialMP;
      } /*else {
        if (datoTipo === "Serial") {
          filter = {
            and: [
              {
                or: [{
                  serialRecibaBTI: {
                    eq: dato.toUpperCase(),
                  }
                },
                {
                  serial: {
                    eq: datoE,
                  },
                }, {
                  serial: {
                    eq: dato,
                  },
                }, {
                  id: {
                    eq: dato,
                  }
                },
                ]
              },
              {
                activo: {
                  eq: true,
                },
              },
              {
                piezasEnPlanta: {
                  eq: true,
                },
              },
              {
                piezasenAlmacen: {
                  gt: 0,
                },
              },
            ],
          };
        }
        datosSerial = await GetRecibaSeriales(filter);
      }*/
      //Si se buscan datos por número de parte.
      if (datoTipo === "NumeroParte") {
        //Se filtran los datos pendientes de planificar
        datosSerial = datosSerial.filter(serialNP => (serialNP.cantidadRecibida ? serialNP.cantidadRecibida : 0) >
          (serialNP.cantidadPlaneada ? serialNP.cantidadPlaneada : 0));
        //Se  suman los datos requeridos
        var datosNP = { materialEnCantidad: 0, piezasenAlmacen: 0, cantidadPlaneada: 0, cantidadRecibida: 0 }
        await Promise.all(datosSerial.map((serialNP) => {
          datosNP.materialEnCantidad = datosNP.materialEnCantidad + parseInt(serialNP.materialEnCantidad ? serialNP.materialEnCantidad : 0);
          datosNP.piezasenAlmacen = datosNP.piezasenAlmacen + serialNP.piezasenAlmacen;
          datosNP.cantidadPlaneada = datosNP.cantidadPlaneada + parseInt(serialNP.cantidadPlaneada ? serialNP.cantidadPlaneada : 0);
          datosNP.cantidadRecibida = datosNP.cantidadRecibida + serialNP.cantidadRecibida;
          return serialNP;
        }));
        setRecibaSNP(datosSerial);
        recibaData = {
          ...datosSerial[0], materialEnCantidad: datosNP.materialEnCantidad,
          piezasenAlmacen: datosNP.piezasenAlmacen, cantidadPlaneada: datosNP.cantidadPlaneada, cantidadRecibida: datosNP.cantidadRecibida
        }
      } else {
        if (datosSerial[0]) {
          recibaData = datosSerial[0];
        }
      }
    } else {
      recibaData = await GetRecibaSerialesID(dato);
    }
    if (recibaData.cantidadRecibida <= 0 || recibaData.cantidadRecibida <= recibaData.cantidadPlaneada) {
      recibaData = {}
    }

    return recibaData;
  }
  // handle input change
  function handleInputChangeCantidadCarga(e, index, list) {
    const { name, value } = e.target;
    const re = /^[0-9\.]+$/;
    if (e.target.value === "" || re.test(e.target.value)
      || e.target.name === "numeroRackCarga" || e.target.name === "rackTipo") {
      list[index][name] = value;
      /*if (e.target.name === "piezasenCargando") {
        //const piezasxRack = parseFloat(list[index].cantidadPlaneada) / parseFloat(list[index].racks);
        list[index].rackCarga = list[index].piezasenCargaDisponibles === value ?
          list[index].racks : (parseFloat(value) / parseFloat(list[index].pproduccion.piezasXRack)).toFixed(2);
        list[index][name] = value;
      }*/
    }

    return list;
  }
  // handle input change
  function onChangeEspaciosVacios(value) {
    const re = /^[0-9\.]+$/;
    if (value === "" || re.test(value)) {
      setEspaciosVacios(value);
      guardarEspaciosVacios(value === "" ? 0 : parseInt(value));
    }
  }
  //Guarda los espacios vacíos
  async function guardarEspaciosVacios(espacios) {
    setAVisible(false);
    setPara("");
    setCargando(true);
    try {
      var PProduccionGeneralID = {};
      if (idProduccionGeneral === "") {
        window.scrollTo(0, 0);
        setMensajeAlert("No hay datos de carga de material para el día de hoy, favor de recargar la applicación e intentarlo nuevamente");
        setColor("warning");
        setCargando(false);
        setAVisible(true);
      } else {
        PProduccionGeneralID = await GetPProduccionGeneralID(
          idProduccionGeneral
        );
        setMensajeAlert("Datos obtenidos 2");

        const hora = Moment(new Date()).format("HH:mm");
        const datosV = { espacioVacio: espacios, fecha: Moment(new Date()).format("YYYY-MM-DD"), hora: hora, Reg_Ins_Usuario: userName }
        if (PProduccionGeneralID.id) {
          const espacioh = PProduccionGeneralID.espacioHistorial ? PProduccionGeneralID.espacioHistorial : [];
          espacioh.push(datosV);
          setIDProduccionGeneral(PProduccionGeneralID.id);
          delete PProduccionGeneralID.createdAt;
          delete PProduccionGeneralID.updatedAt;
          delete PProduccionGeneralID.__typename;
          PProduccionGeneralID.espacioVacio = espacios;
          PProduccionGeneralID.espacioHora = (PProduccionGeneralID.espacioHora ? (PProduccionGeneralID.espacioHora + ",") : "") + espacios + " " + hora;
          PProduccionGeneralID.Reg_Mod_Usuario = userName;
          PProduccionGeneralID.espacioHistorial = espacioh;
          await API.graphql({
            query: updatePProduccionGeneral,
            variables: { input: PProduccionGeneralID },
          });
          const rOperacion = await manageResumenOperacion(Moment(new Date()).format("YYYY-MM-DD"), PProduccionGeneralID, "Producción", userName, idProduccionGeneral);
          window.scrollTo(0, 0);
          setMensajeAlert("Operación exitosa");
          setColor("info");
          setCargando(false);
          setAVisible(true);

        } else {
          window.scrollTo(0, 0);
          setMensajeAlert("No hay datos de carga de material para el día de hoy, favor de recargar la applicación e intentarlo nuevamente");
          setColor("warning");
          setCargando(false);
          setAVisible(true);
        }
      }
    } catch (e) {
      window.scrollTo(0, 0);
      /*setMensajeAlert(
        "No fue posible realizar la operación: revise su conexión a internet, recargue la página y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas"
      );*/
      setColor("warning");
      setCargando(false);
      setAVisible(true);
    }
  }
  function moveralSiguiente() {
    window.scrollTo(0, 400 * indexCarga + 300);
  }
  function clicCarga() {
    if (textBCarga === "Carga") {
      setTextBCarga("Terminar Carga");
      setCargaCompleta(false);
      // moveralSiguiente();
    } else {
      setTextBCarga("Carga");
      //fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
    }
    setCargandoSinQR(false);
  }
  function cargaSinQR(index) {
    const idSerial = pProduccionPEyP[index].recibaSerialID;
    handleScan(idSerial);
    setCargandoSinQR(true);
  }
  //Obtiene los datos de la última ubicación del material guardados en recibaSeriales
  function obtenerUltimaUbicacionPlaneacion(ubicacion) {
    var locaciones = "";
    var locacion = "";
    if (ubicacion) {
      ubicacion.map(x => (
        locacion = "",
        locacion = x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', ''),
        locaciones = locacion === "" ? locaciones : locaciones === "" ? locacion : locaciones + ", " + locacion
      ));
    }
    return locaciones;
  }
  async function cargaManual(serialBTI) {
    const idSerial = pProduccionPEyP.filter(pProduccion => pProduccion.serialRecibaBTI === serialBTI.toUpperCase());
    if (idSerial.length > 0) {
      handleScan(idSerial[0].recibaSerialID);
    } else {
      await preCarga("Serial", serialBTI);
    }
  }
  async function preCarga(tipo, dato) {
    setAVisible(false);
    setCargando(true);
    setCargandoSinQR(true);
    setPara("");
    var recibap = {};
    const claveNP = dato.substr(0, 4);
    if (claveNP === "NP&R" || claveNP === "NP/R") {
      //setSporNPU(true);
      //recibap = await fecthReciba("NumeroParte", dato);
      window.scrollTo(0, 0);
      setColor("warning");
      setMensajeAlert("Operación denegada; La etiqueta maestra no está disponible para carga, intente la carga por serial.");
      setAVisible(true);
      setCargando(false);
      return;
    } else {
      setSporNPU(false);
      recibap = await fecthReciba(tipo, dato);
    }
    if (recibap.id && ((recibap.Ecoat === true || (recibap.precioUnitario ? recibap.precioUnitario : 0) > 0))) {
      setRecibaOriginal(recibap);
      const productosID = await GetProductosID(recibap.productoID);
      const cantidadPiezasD = recibap.cantidadRecibida - recibap.cantidadPlaneada;
      const piezasRack = productosID.piezasXRack ? productosID.piezasXRack : recibap.piezasXRack;
      const rackTipo = productosID.rackTipo ? productosID.rackTipo : recibap.rackTipo;
      var lista = {
        fechaDePlaneacion: Moment(new Date()).format("YYYY-MM-DD"), numero: 0, recibaSerialID: recibap.id, clienteID: recibap.clienteID,
        productoID: recibap.productoID, cliente: recibap.cliente, numerodeParte: recibap.numerodeParte,
        descripcion: recibap.descripcion, serial: recibap.serial, serialRecibaBTI: recibap.serialRecibaBTI,
        locacion: obtenerUltimaUbicacionPlaneacion(recibap.ultimaUbicacion), divisa: recibap.divisa, rackTipo: rackTipo,
        cantidadPiezas: cantidadPiezasD, materialEn: recibap.materialEn, precioUnitario: recibap.precioUnitario,
        materialEnCantidad: ((cantidadPiezasD) / (recibap.piezasenAlmacen / recibap.materialEnCantidad)), piezasXRack: piezasRack,
        prioridad: 1, racks: piezasRack ? piezasRack > 0 ? (parseFloat(cantidadPiezasD) / parseFloat(piezasRack)).toFixed(2) : '' : '',
        prioridadOriginal: 0, racksOriginal: "", materialEnCantidadOriginal: "", ciclosOriginal: "",
        cantidadDisponible: cantidadPiezasD, ciclos: '1', activo: true, Reg_Ins_Usuario: '', Reg_Mod_Usuario: '',
        cantidadPlaneadaOriginal: !recibap.cantidadPlaneada ? 0 : recibap.cantidadPlaneada, cantidadPiezasCargando: cantidadPiezasD,
        cicloCarga: 1, rackCarga: piezasRack ? piezasRack > 0 ? (parseFloat(cantidadPiezasD) / parseFloat(piezasRack)).toFixed(2) : '' : '',
        sporNP: claveNP === "NP&R" ? true : false, krecibaNP: claveNP === "NP&R" ? recibap.krecibaNP ? recibap.krecibaNP : "" : ""
      }
      setRegistroNuevoPP(lista);
      setPCSerialBTI("");
      setModal(!modal);
    } else {
      if (dato.length > 30) {
        const datoReciba = await GetRecibaSerialesID(dato);
        if (datoReciba.id && ((datoReciba.Ecoat === true || (datoReciba.precioUnitario ? datoReciba.precioUnitario : 0) > 0))) {
          {/*<GeneralProduccion
            sProduccion={datoReciba}
            bColor={"warning mr-2"}
            btitle={"Embarcar Material"}
            modulo={"Producción"}
            usuario={userName}
            modalO={true}
            valorDeREtorno={notificacionCreada}
          />*/}
          setColor("warning");
          setPara("Reciba");
          setMensajeAlert("Material no disponible para su planificación; Favor de revisar que el número de serie o id (" + datoReciba.serialRecibaBTI + ") sea el correcto, que el estatus de reciba del contenedor en cuestión sea Aceptado, que el material requiera el proceso de Ecoat, y que no esté ya en el plan de producción.");
          setAVisible(true);
        } else {
          setColor("warning");
          setPara("Reciba");
          setMensajeAlert("Material no disponible para su planificación; Favor de revisar que el número de serie o id (" + dato + ") sea el correcto, que el estatus de reciba del contenedor en cuestión sea Aceptado, que el material requiera el proceso de Ecoat,, y que no esté ya en el plan de producción.");
          setAVisible(true);
        }
      } else {
        setColor("warning");
        setPara("Reciba");
        setMensajeAlert("Material no disponible para su planificación; Favor de revisar que el número de serie o id (" + dato + ") sea el correcto, que el estatus de reciba del contenedor en cuestión sea Aceptado, y que no esté ya en el plan de producción.");
        setAVisible(true);
      }
      //fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
    }
    setCargando(false);
  }
  async function aceptarCargar(indexCarga) {
    //pProduccionPEyP[indexCarga].piezasenCargando = pProduccionPEyP[indexCarga].cantidadPiezas;
    setAVisible(false);
    setPara("");
    setCargando(true);
    setColor("warning");
    //subscriptions.unsubscribe();
    if (cargaCompleta === false) {
      setModal2(!modal2);
    }
    try {
      //setMensajeAlert("Iniciando la carga: " + pProduccionPEyP[indexCarga].piezasenCargaDisponibles);
      if (pProduccionPEyP[indexCarga].piezasenCargando > 0) {
        //Se revisa si la cantidad especificada en cargando no sea mayor a la cantidad del plan deproducción
        if (
          (pProduccionPEyP[indexCarga].piezasenCargando > pProduccionPEyP[indexCarga].piezasenCargaDisponibles) ||
          (pProduccionPEyP[indexCarga].piezasenCargando > pProduccionPEyP[indexCarga].cantidadPiezas) ||
          (!pProduccionPEyP[indexCarga].rackCarga) || (!pProduccionPEyP[indexCarga].piezasenCargando)
        ) {
          window.scrollTo(0, 0);
          //Si es mayor se manda un mensaje
          setMensajeAlert(
            "No fue posible realizar la operación: La cantidad en carga no puede ser mayor a la disponible para carga," +
            " el número de Racks y la Cantidad son obligatorios");
          setColor("warning");
          setCargando(false);
          setAVisible(true);
        } else {
          //setMensajeAlert("Iniciando a revisar la concurrencia");
          var pConcurrencia = false;
          //Se obtienen los datos del plan de producción por número para revisar la concurrencia
          //setMensajeAlert("Obteniendo los datos de producción, concurrencia");
          //Se obtienen los datos de  reciba seriales para revisar la concurrencia.
          const pProduccionFromAPI = await GetRecibaSerialesID(pProduccionPEyP[indexCarga].recibaSerialID); //.data.listPProduccions.items;
          //setMensajeAlert("Datos obtenidos, concurrencia");
          //Si no existen datos, se considera que existe concurrencia
          if (!pProduccionFromAPI.id) {
            pConcurrencia = true;
            //setMensajeAlert("Menor que 1");
          } else {
            //Si existen datos, se revisa si las fechas de actualización de los registros es la misma
            //Si no es la misma fecha de actualización de ambos registros, se considera que existe concurrencia
            if (
              pProduccionFromAPI.piezasenCarga !==
              pProduccionPEyP[indexCarga].piezasenCarga
            ) {
              pConcurrencia = true;
              //setMensajeAlert("Diferente UpdateAt, Update tabla: " + pProduccionFromAPI.updatedAt + " Update registro leido: " + pProduccionPEyP[indexCarga].updatedAt);
            }
          }
          //setMensajeAlert("Concurrencia revisada");
          //Si no existe concurrencia, se actualizan los datos en RecibaSeriales y se actualiza el número de piezasenCarga  en pProduccion
          //Además, se guarda la ubicación en Ubicaciones
          if (pConcurrencia === false) {
            //Se obtiene el registro más reciente del serial en el plan de producción, para revisar
            // concurrencia y el valor de terminado.
            var pproduccionGID = "";
            setMensajeAlert("Obteniendo datos; 1");
            const ppg = await GetPProduccionGeneral({ and: [{ fechaDePlaneacion: { eq: fechaPlaneacion } }, { activo: { eq: true } }] });
            setMensajeAlert("Obteniendo datos; 2");
            //Se actualiza el registro general de plan de producción.          
            if (ppg.length > 0) {
              pproduccionGID = ppg[0].id;
              const pproduccionG = ppg[0];
              const datoRepetido = pproduccionG.recibaSerialIDS ? await pproduccionG.recibaSerialIDS.filter(datosPProduccion =>
                datosPProduccion.includes(pProduccionPEyP[indexCarga].recibaSerialID)) : [];
              if (!datoRepetido[0]) {
                const brecibaSerialIDS = pproduccionG.recibaSerialIDS ?
                  [...pproduccionG.recibaSerialIDS, { id: pProduccionPEyP[indexCarga].recibaSerialID }] :
                  [{ id: pProduccionPEyP[indexCarga].recibaSerialID }];

                const rPProduccion = {
                  ...pproduccionG,
                  recibaSerialIDS: brecibaSerialIDS,
                  Reg_Mod_Usuario: userName
                };

                delete rPProduccion.createdAt;
                delete rPProduccion.updatedAt;
                delete rPProduccion.__typename;
                setMensajeAlert("Problemas al actualizar el plan de producción general 2 " + JSON.stringify(rPProduccion));
                await API.graphql({ query: updatePProduccionGeneral, variables: { input: rPProduccion } });
              }
            } else { //Si no existe, se crea el número de plan de producción en la tabla PProduccionUltimoNumero
              setMensajeAlert("Obteniendo datos; 3");
              var numeroUP = 1;
              const apiData = await API.graphql({ query: listPProduccionUltimoNumeros, variables: { limit: 100000000 } });
              const ultimapFromAPI = apiData.data.listPProduccionUltimoNumeros.items;
              //await Promise.all(ultimapFromAPI.map(async ultimaplaneacion => {
              if (ultimapFromAPI.length > 0) {
                const ultimaplaneacion = ultimapFromAPI[0];
                numeroUP = ultimaplaneacion.numero + 1;
                ultimaplaneacion.numero = numeroUP;

                delete ultimaplaneacion.createdAt;
                delete ultimaplaneacion.updatedAt;
                delete ultimaplaneacion.__typename;
                ultimaplaneacion.Reg_Mod_Usuario = userName;
                await API.graphql({ query: updatePProduccionUltimoNumero, variables: { input: ultimaplaneacion } })

                //return ultimaplaneacion;
                //}))
              } else {//(!ultimapFromAPI.length) 
                await API.graphql({
                  query: createPProduccionUltimoNumero, variables: {
                    input: {
                      numero: numeroUP, activo: true, Reg_Ins_Usuario: userName
                    }
                  }
                });
              }
              //Se crea el registro de la plan de producción general
              setMensajeAlert("Problemas al guardar la planeación general 1");
              let resulppg = await API.graphql({
                query: createPProduccionGeneral, variables: {
                  input: {
                    fechaDePlaneacion: fechaPlaneacion,
                    numero: numeroUP,
                    espacioVacio: 0,
                    porSerial: true,
                    recibaSerialIDS: [{ id: pProduccionPEyP[indexCarga].recibaSerialID }],
                    activo: true,
                    Reg_Ins_Usuario: userName
                  }
                }
              });
              pproduccionGID = resulppg.data.createPProduccionGeneral.id;
            }
            //Se obtienen los datos de la reciba seriales por ID
            const recibaFromAPI = pProduccionFromAPI;

            //Se asigna el valor de la fecha de la carga
            const fechacarga = Moment(new Date()).format("YYYY-MM-DD");
            const horacarga = Moment(new Date()).format("HH:mm");
            const fechahoracarga = Moment(fechacarga + " " + horacarga).format("YYYY-MM-DD HH:mm");
            const piezasfechayhora = pProduccionPEyP[indexCarga].piezasenCargando + " " + fechahoracarga;
            pProduccionPEyP[indexCarga].cargaFechaHora = !pProduccionPEyP[indexCarga].cargaFechaHora ?
              piezasfechayhora : pProduccionPEyP[indexCarga].cargaFechaHora + ", " + piezasfechayhora;
            //Creación o actualización de registro en pProducción   
            const datosCarga = {
              produccionGID: pproduccionGID, fechaDePlaneacion: pProduccionPEyP[indexCarga].fechaDePlaneacion,
              fecha: fechacarga, hora: horacarga, cantidadPiezas: pProduccionPEyP[indexCarga].cantidadPiezas,
              materialEnCantidad: pProduccionPEyP[indexCarga].materialEnCantidad, racks: pProduccionPEyP[indexCarga].racks,
              piezasenCarga: pProduccionPEyP[indexCarga].piezasenCargando, ciclos: pProduccionPEyP[indexCarga].ciclos,
              numeroRackCarga: pProduccionPEyP[indexCarga].numeroRackCarga ? pProduccionPEyP[indexCarga].numeroRackCarga : "",
              Reg_Ins_Usuario: userName, modulo: "Producción", rackTipo: pProduccionPEyP[indexCarga].rackTipo
            }

            if (recibaFromAPI.id) {
              //Se cambia la ubicación del material de almacén a carga
              const loacionAnterior = "";
              const ubicacionAnterior = "Almacén";
              const loacionPiezas = "Carga";
              const ubicacionPiezas = "Producción";
              const cantidadPiezas = pProduccionPEyP[indexCarga].piezasenCargando;
              var cambioUbicacionAux = [];
              setMensajeAlert("Antes de obtener los datos del cambio de ubicación");
              cambioUbicacionAux = await cambioUbicacionSeriales(
                recibaFromAPI,
                ubicacionAnterior,
                loacionAnterior,
                ubicacionPiezas,
                loacionPiezas,
                cantidadPiezas);
              setMensajeAlert("Despues de obtener los datos del cambio de ubicación" + JSON.stringify(cambioUbicacionAux));
              if (cambioUbicacionAux.mensaje != "") {
                setMensajeAlert(cambioUbicacionAux.mensaje);
                setColor(cambioUbicacionAux.color);
                setCargando(false);
                setAVisible(true);
                return;
              } else {
                recibaFromAPI.ultimaUbicacion = cambioUbicacionAux.sUltimaU;
                recibaFromAPI.rubicaciones = cambioUbicacionAux.sUbicaciones
                setMensajeAlert("Ubicaciones agrupadas");
              }
              //Se actualizan los datos de carga en reciba
              //Se actualiza el registro de carga
              const datosCargandor = recibaFromAPI.registroCarga ? recibaFromAPI.registroCarga : [];
              await datosCargandor.push(datosCarga);
              //Datos de plandeproducción
              recibaFromAPI.racks = parseFloat(recibaFromAPI.racks ? recibaFromAPI.racks : 0) + parseFloat(pProduccionPEyP[indexCarga].rackCarga);
              recibaFromAPI.ciclos = parseInt(recibaFromAPI.ciclos ? recibaFromAPI.ciclos : 0) + parseInt(pProduccionPEyP[indexCarga].cicloCarga);
              recibaFromAPI.ultimoRack = pProduccionPEyP[indexCarga].numeroRackCarga;
              recibaFromAPI.numeroCarga = (recibaFromAPI.numeroCarga ? recibaFromAPI.numeroCarga : 0) + 1;
              recibaFromAPI.registroCarga = datosCargandor;

              delete recibaFromAPI.createdAt;
              delete recibaFromAPI.updatedAt;
              delete recibaFromAPI.__typename;
              recibaFromAPI.piezasenCarga = !recibaFromAPI.piezasenCarga
                ? pProduccionPEyP[indexCarga].piezasenCargando
                : parseInt(recibaFromAPI.piezasenCarga) +
                parseInt(pProduccionPEyP[indexCarga].piezasenCargando);
              recibaFromAPI.piezasenAlmacen =
                recibaFromAPI.piezasenAlmacen -
                pProduccionPEyP[indexCarga].piezasenCargando;
              recibaFromAPI.cargaFechaHora = pProduccionPEyP[indexCarga].cargaFechaHora;
              recibaFromAPI.Reg_Mod_Usuario = userName;
              let upRecibaS = await API.graphql({
                query: updateRecibaSeriales,
                variables: { input: recibaFromAPI },
              });
              //Se actualizan los datos en recibaSerialesMP
              const recibaSerialMPID = recibaFromAPI.recibaSerialMPID;
              if (recibaFromAPI.recibaSerialMPID) {
                delete recibaFromAPI.recibaSerialMPID;
                setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(recibaFromAPI));
                await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...recibaFromAPI, id: recibaSerialMPID, rsUpdatedAt: upRecibaS.data.updateRecibaSeriales.updatedAt } }, });
              }

              setIDProduccionGeneral(pproduccionGID);
              //Se registra el dato de Resultado de operación
              const rOperacion = await manageResumenOperacion(fechacarga, pProduccionPEyP[indexCarga], "Producción", userName, pproduccionGID);
            } else {
              setMensajeAlert("Operación errónea, no se encontraron registros de ubicación disponible");
              setColor("warning");
              setCargando(false);
              setAVisible(true);
              return;
            }

            window.scrollTo(0, 0);
            setMensajeAlert("Operación exitosa");
            setColor("primary");

            setCargando(false);
            setAVisible(true);
            if (cargaCompleta === false) {
              fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
            }
            /*if (cargandoSinQR === false) {
              setTextBCarga("Terminar Carga");
            }*/
          } else {
            //Si  hay concurrencia se tienen que actualizar los datos
            window.scrollTo(0, 0);
            setMensajeAlert(
              "No fue posible realizar la operación: existe concurrencia, favor de recargar los datos y " +
              " volver a intentarlo"
            );
            setColor("warning");
            setCargando(false);
            setAVisible(true);
            fetchPlanProduccionPEyP(idProduccionGeneral, filtroVer);
          }
        }
      }
    } catch (e) {
      window.scrollTo(0, 0);
      /*setMensajeAlert(
        "No fue posible realizar la operación: revise su conexión a internet, recargue la página y vuelva a intentar, si el error persiste, favor de comunicarse a sistemas"
      );*/
      setColor("warning");
      setCargando(false);
      setAVisible(true);
    }
  }
  async function aceptarPintado(particular, index) {
    setAVisible(false);
    setPara("");
    setCargando(true);
    setHabilitado(true);
    const pProduccionPintado = pProduccionPEyP.filter(
      (pproduccion) => !particular ? pproduccion.seleccionada === true : pproduccion.id === pProduccionPEyP[index].id);
    const result = await clicPintado(pProduccionPintado, fechaPlaneacion, userName, "Producción");

    if (result.completo === true) {
      setIDProduccionGeneral(result.pproduccionGID);
    }
    setCargando(false);
    window.scrollTo(0, 0);
    setColor(result.color);
    setMensajeAlert(result.mensaje);
    setAVisible(true);
    recargarPagina();
  }
  function onChangesCheckCarga(lista, i, e) {
    //e.persist();
    var sinSeleccion = true;
    if (i === -1) {
      lista.map((pProduccion) => {
        if (
          pProduccion.piezasenCarga > 0 &&
          pProduccion.piezasenPintado < pProduccion.piezasenCarga
        ) {
          if (e.target.checked === true) {
            setCargaCHKS(e.target.checked);
            pProduccion.seleccionada = e.target.checked;
            sinSeleccion = false;
          } else {
            pProduccion.seleccionada = false;
          }
        }
        setCargaCHKS(e.target.checked);
        return pProduccion;
      });
    } else {
      setCargaCHKS(false);
      if (lista[i].seleccionada === false || !lista[i].seleccionada) {
        lista[i].seleccionada = true;
        sinSeleccion = false;
      } else {
        lista[i].seleccionada = false;
      }
    }
    setHabilitado(sinSeleccion);
    return lista;
  }
  function onChangesCheckVSD(e) {
    setVerPProduccionSiguiente(e.target.checked);
    if (e.target.checked === true) {
      const diaM = new Date();
      diaM.setDate(diaM.getDate() + 1);
      setFechaPlaneacion(Moment(diaM).format("YYYY-MM-DD"));
      fetchPProduccionGeneral(Moment(diaM).format("YYYY-MM-DD"));
    } else {
      setFechaPlaneacion(Moment(now).format("YYYY-MM-DD"));
      fetchPProduccionGeneral(Moment(now).format("YYYY-MM-DD"));
    }
  }
  function handleInputChange(e) {
    const { name, value } = e.target;
    const re = /^[0-9\.]+$/;
    if (e.target.value === '' || re.test(e.target.value)) {
      if (name === "prioridad") {
        setRegistroNuevoPP({ ...registroNuevoPP, prioridad: parseInt(e.target.value) })
      }
      if (name === "racks") {
        setRegistroNuevoPP({ ...registroNuevoPP, racks: e.target.value })
      }
      if (name === "cantidadPiezas") {
        setRegistroNuevoPP({ ...registroNuevoPP, cantidadPiezas: e.target.value })
      }
      if (name === "ciclos") {
        setRegistroNuevoPP({ ...registroNuevoPP, ciclos: e.target.value })
      }
      if (name === "materialEnCantidad") {
        setRegistroNuevoPP({ ...registroNuevoPP, materialEnCantidad: e.target.value })
      }
      if (name === "cantidadPiezasCargando") {
        setRegistroNuevoPP({ ...registroNuevoPP, cantidadPiezasCargando: e.target.value, cantidadPiezas: parseInt(e.target.value) })
      }
      if (name === "cicloCarga") {
        setRegistroNuevoPP({ ...registroNuevoPP, cicloCarga: parseInt(e.target.value), ciclos: parseInt(e.target.value) })
      }
      if (name === "rackCarga") {
        setRegistroNuevoPP({ ...registroNuevoPP, rackCarga: e.target.value, racks: e.target.value })
      }
      if (name === "numeroRackCarga") {
        setRegistroNuevoPP({ ...registroNuevoPP, numeroRackCarga: e.target.value })
      }
    }
    if (name === "rackTipo") {
      setRegistroNuevoPP({ ...registroNuevoPP, rackTipo: e.target.value })
    }
    //setRegistroNuevoPP(registroNuevoPP);
    /*if (e.target.name === "cantidadPiezas" && list.piezasXRack) {
      list.racks = (parseFloat(value) / parseFloat(list.piezasXRack)).toFixed(2);
    }*/
    //FaltanDatosPlaneacion(list);
    //return list
  };
  async function managePProduccion() {
    setGuardando(true);
    setAVisible(false);
    setPara("");
    setCargando(true);
    //subscriptions.unsubscribe();
    const result = await guardarCargaPintado(registroNuevoPP, userName, "Producción", idProduccionGeneral, sporNPU, recibaOriginal);
    setCargando(false);
    setMensajeAlert(result.mensaje);
    setColor(result.color);
    setGuardando(false);
    setAVisible(true);
    toggle();
    await fetchPProduccionGeneral(fechaPlaneacion);

  };

  //Búsqueda en plan de producción
  function onChangeVer(e) {
    setFiltroVer(e.target.value);
    busquedaPProduccion(pProduccionPEyPSinfiltro, e.target.value);
  }
  //Búsqueda serial en el plan de producción
  function bucarNSB(e) {
    setFiltroVer("NSB");
    //busquedaPProduccion(pProduccionPEyPSinfiltro, "NSB");
    fetchPlanProduccionPEyP(idProduccionGeneral, "NSB");
  }

  //Búsqueda serial en el plan de producción
  function onChangeIS(e) {
    setPCSerialBTI(e.target.value);
    if (filtroVer === "NSB" && e.target.value === "") {
      setFiltroVer("Todo");
      //busquedaPProduccion(pProduccionPEyPSinfiltro, "Todo");
      fetchPlanProduccionPEyP(idProduccionGeneral, "Todo");
    }
  }
  return (
    <>
      {ppproduccion === true && (
        <>
          <Fragment>
            <Row>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                {pProduccionPEyP.length > 0 && (
                  <h5 className=" floatleft">
                    Plan de producción Ecoat del{" "}
                    {Moment(pProduccionPEyP[0].fechaDePlaneacion).format(
                      "DD/MM/YYYY"
                    )}
                  </h5>
                )}
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px text">
                {textBCarga === "Terminar Carga" && (
                  <>
                    {guardando === false && (
                      <QrReader
                        delay={300}
                        onError={handleError}
                        onScan={handleScan}
                        className="qrReader"
                      />
                    )}
                    <Label className="floatleft">
                      <input
                        type="checkbox"
                        name="CBCC"
                        checked={cargaCompleta}
                        onChange={(e) => setCargaCompleta(e.target.checked)}
                        className="ml-2"
                      />
                      Carga completa
                    </Label>
                  </>
                )}
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12 margintop20px">
                {verPProduccionSiguiente === false && ( //Si se está mostrando el plan de producción del siguiente día, no se permite pasar el material a pintado.
                  <>
                    <button
                      className="cbutton  floatright ml-2 bcolorb"
                      title="Pintado"
                      hidden={pProduccionPEyP.length ? false : true}
                      onClick={() => {
                        aceptarPintado();
                      }}
                      disabled={habilitado}
                    >
                      {" "}
                      Pintado
                    </button>
                  </>
                )}
                <button
                  className="cbutton  floatright  ml-2 btn-primary"
                  title="Carga"
                  //hidden={pProduccionPEyP.length ? false : true}
                  onClick={() => {
                    clicCarga();
                  }}
                >
                  {textBCarga}
                </button>
                <button
                  className="cbutton btn-dark floatright  ml-2 "
                  title="Recargar página"
                  onClick={() => {
                    recargarPagina();
                  }}
                >
                  <IoIcons.IoMdRefresh /> Recargar{" "}
                </button>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 margintop20px " >
                <div class="input-group">
                  <Input name="area"
                    value={pCSerialBTI}
                    onChange={(e) => onChangeIS(e)}
                    placeholder="Ingresa el Serial/Serial BTI"
                  />
                  <div class="input-group-prepend">
                    <button class="cbuttonS floatleft btn-primary" title="Carga manual" onClick={() => { cargaManual(pCSerialBTI); }}> <IoIcons.IoMdCloudUpload /> </button>
                  </div>
                  <div class="input-group-prepend ml-1">
                    <button class="cbuttonS floatleft btn-primary" title="Buscar por número de parte, serial o serial BTI" onClick={e => bucarNSB(e)}> <IoIcons.IoMdSearch /> </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-6 col-sm-12 col-xs-12 margintop20px"></div>
            </Row>
            <Row>
              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                <Alert color={color} isOpen={aVisible} toggle={onDismiss}>
                  {mensajeAlert}
                  {para !== "" && (
                    <Notificar
                      datosReciba={{}}
                      mensaje={mensajeAlert}
                      btitle={"Enviar notificación a " + para}
                      bColor={"success  ml-1"}
                      para={para}
                      modulo={"Produccion"}
                      accion={"Problemas al registrar carga"}
                      peticionAutTipo={""}
                      tipoNotific={"Problemas-Carga"}
                      usuario={userName}
                      paraSoporte={false}
                      valorDeREtorno={notificacionCreada}
                    />
                  )}
                </Alert>
              </div>
              {cargando === true && (
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                  <img width="150px" src="assets/img/preloader.gif" />
                </div>
              )}
            </Row>
            <Row>
              <div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
                <Label className="floatleft ">
                  Ver:
                </Label>
              </div>
              <div className="col-lg-2 col-md-2 col-sm-11 col-xs-11 ">
                <select
                  name="filtro"
                  className=" custom-select floatleft marginlbusqueda"
                  onChange={e => onChangeVer(e)}
                >
                  <option value="Todo" selected={filtroVer == "Todo" ? true : false}>
                    Todo
                  </option>
                  <option value="No cargados" selected={filtroVer == "No cargados" ? true : false}>
                    No cargados
                  </option>
                  <option value="No pintados" selected={filtroVer == "No pintados" ? true : false}>
                    No pintados
                  </option>
                  <option value="No atrasados" selected={filtroVer == "No atrasados" ? true : false}>
                    No atrasados
                  </option>
                  <option value="Cargados" selected={filtroVer == "Cargados" ? true : false}>
                    Cargados
                  </option>
                  <option value="Pintados" selected={filtroVer == "Pintados" ? true : false}>
                    Pintados
                  </option>
                  <option value="Atrasados" selected={filtroVer == "Atrasados" ? true : false}>
                    Atrasados
                  </option>
                </select>
              </div>
              {pProduccionPEyP.length > 0 && (
                <>
                  {verPProduccionSiguiente === false && (
                    (idProduccionGeneral != "") && (
                      <>
                        <div
                          className={
                            verPPSiguiente === true
                              ? "col-lg-2 col-md-2 col-sm-12 col-xs-12"
                              : " col-lg-2 col-md-2 col-sm-12 col-xs-12"
                          }
                        >
                          <Label className="floatrightleft">
                            Espacios vacíos:
                          </Label>
                        </div>
                        <div
                          className={
                            verPPSiguiente === true
                              ? "col-lg-2 col-md-2 col-sm-12 col-xs-12"
                              : " col-lg-2 col-md-2 col-sm-12 col-xs-12"
                          }
                        >

                          <div class="input-group">
                            <div class="input-group-prepend">
                              <button
                                class="cbuttonS btn-success "
                                disabled={cargando}
                                onClick={() =>
                                  onChangeEspaciosVacios(
                                    espaciosVacios > 0 ? parseInt(espaciosVacios) - 1 : 0
                                  )
                                }
                              >
                                <IoIcons.IoIosRemove />
                              </button>
                            </div>
                            <Input
                              className="textaligmentcenter"
                              name="espacioVacio"

                              value={espaciosVacios}
                              onChange={(e) =>
                                onChangeEspaciosVacios(e.target.value)
                              }
                            />
                            <button
                              class="cbuttonS btn-success"
                              disabled={cargando}
                              onClick={() =>
                                onChangeEspaciosVacios(
                                  espaciosVacios != "" ? parseInt(espaciosVacios) + 1 : 1
                                )
                              }
                            >
                              <IoIcons.IoIosAdd />
                            </button>
                          </div>
                        </div>

                      </>
                    ))}

                </>
              )}
              <div className={"col-lg-5 col-md-5 col-sm-12 col-xs-12 displayMobil margintop10px"}>
                <Label className="floatrightleft ">
                  <input
                    type="checkbox"
                    name="CBVPPP"
                    checked={cargaCHKS}
                    onChange={(e) =>
                      setPProduccionPEyP(
                        onChangesCheckCarga(
                          [...pProduccionPEyP],
                          -1,
                          e
                        ))}
                    className="ml-2"
                  />
                  Seleccionar registros en carga
                </Label>
              </div>
            </Row>
            {pProduccionPEyP.length > 0 && (
              <>
                <Row>
                  <div className={pProduccionPEyP.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                    " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                    <Table className=" mb-2  ">
                      <Thead class="thead-secondary">
                        <Tr>
                          <Th>No.</Th>
                          <Th className="minwidth200px">Cliente</Th>
                          <Th className="minwidth100px">Número de parte</Th>
                          <Th className="minwidth100px">Descripción</Th>
                          <Th>Serial</Th>
                          <Th className="minwidth100px">Serial BTI</Th>
                          <Th>Lote</Th>
                          <Th>Cantidad Recibida</Th>
                          <Th className="minwidth100px ">Cantidad planeada</Th>
                          <Th>Racks</Th>
                          {/*<Th>Cantidad disponible carga</Th>*/}
                          <Th className="minwidth60px">Ciclos</Th>
                          <Th className="minwidth100px ">
                            <input
                              type="checkbox"
                              name="enProduccion"
                              class="form-check-input displaynoneMobil"
                              disabled={
                                textBCarga === "Terminar Carga" ? true : false
                              }
                              checked={cargaCHKS}
                              onChange={(e) =>
                                setPProduccionPEyP(
                                  onChangesCheckCarga(
                                    [...pProduccionPEyP],
                                    -1,
                                    e
                                  )
                                )
                              }
                            />
                            En carga
                          </Th>
                          <Th className="minwidth100px ">En pintado</Th>
                          <Th>Último rack</Th>
                          {/*<Th className="minwidth100px ">Cantidad recibida</Th>
                          <Th className="minwidth100px ">Cantidad planeada</Th>
                          <Th className="minwidth100px ">Última ubicación</Th>
                          <Th className="minwidth100px ">Fecha de  Carga</Th>
                          <Th className="minwidth100px ">Fecha de  pintado</Th>*/}
                          {(ppcargaManual === true) && ( // && Moment(now).format("YYYY-MM-DD") === "2022-06-20"
                            <Th>Acciones</Th>
                          )}
                        </Tr>
                      </Thead>
                      <Tbody>
                        {pProduccionPEyP.map((pProduccion, i) => (
                          <Tr
                            className={
                              pProduccion.piezasenPintado ===
                                pProduccion.cantidadPlaneada
                                ? "bcolorb"
                                : pProduccion.piezasenCarga ||
                                  pProduccion.piezasenPintado
                                  ? "btn-primary"
                                  : i % 2 !== 0
                                    ? "table-active"
                                    : ""
                            }
                          >
                            <Td>{i + 1}</Td>
                            <Td>{pProduccion.cliente}</Td>
                            <Td>{pProduccion.numerodeParte}</Td>
                            <Td>{pProduccion.descripcion}</Td>
                            <Td
                              className={
                                pProduccion.descripcion
                                  ? ""
                                  : "margintopmobil20px"
                              }
                            >
                              {pProduccion.serial}
                            </Td>
                            <Td>{pProduccion.serialRecibaBTI}</Td>
                            <Td>{pProduccion.lote}</Td>
                            <Td>{pProduccion.cantidadRecibida}</Td>
                            <Td>{pProduccion.cantidadPlaneada}</Td>
                            <Td>
                              {pProduccion.racks}
                            </Td>
                            {/*<Td >{pProduccion.piezasenCargaDisponibles}</Td>*/}
                            <Td>{pProduccion.ciclos}</Td>
                            <Td>
                              {(pProduccion.piezasenCarga ? pProduccion.piezasenCarga : 0) > (pProduccion.piezasenPintado ? pProduccion.piezasenPintado : 0) && (
                                <>
                                  <input
                                    type="checkbox"
                                    name="enProduccion"
                                    class="form-check-input"
                                    disabled={
                                      textBCarga === "Terminar Carga"
                                        ? true
                                        : false
                                    }
                                    checked={pProduccion.seleccionada}
                                    onChange={() =>
                                      setPProduccionPEyP(
                                        onChangesCheckCarga(
                                          [...pProduccionPEyP],
                                          i
                                        )
                                      )
                                    }
                                  />
                                  {(pProduccion.piezasenCarga ? pProduccion.piezasenCarga - (pProduccion.piezasenPintado ? pProduccion.piezasenPintado : 0) : "")}
                                </>
                              )}
                            </Td>
                            <Td
                              className={"margintopmobil20px"
                              }
                            >
                              {pProduccion.piezasenPintado}
                            </Td>
                            <Td>
                              {pProduccion.ultimoRack
                                ? pProduccion.ultimoRack
                                : "--"}
                            </Td>
                            {/*<Td>
                              {pProduccion.cantidadRecibida
                                ? pProduccion.cantidadRecibida
                                : "--"}
                            </Td>
                            <Td>
                              {pProduccion.cantidadPlaneada
                                ? pProduccion.cantidadPlaneada
                                : "--"}
                            </Td>
                            <Td>
                              {pProduccion.ultimaUbicacion
                                ? pProduccion.ultimaUbicacion
                                : "--"}
                            </Td>
                            <Td>
                              {pProduccion.cargaFechaHora
                                ? pProduccion.cargaFechaHora
                                : "--"}
                            </Td>
                            <Td>
                              {pProduccion.pintadoFechaHora
                                ? pProduccion.pintadoFechaHora
                                : "--"}
                            </Td>*/}
                            <Td className={"marginbottommobil40px"
                            }>
                              {/*pProduccion.terminado ? "Terminado" : "No terminado"*/}
                              {(((!pProduccion.piezasenPintado ? 0 : pProduccion.piezasenPintado) +
                                (!pProduccion.piezasenCarga ? 0 : pProduccion.piezasenCarga) -
                                (!pProduccion.piezasenPintado ? 0 : pProduccion.piezasenPintado)) > 0) && ( // && Moment(now).format("YYYY-MM-DD") === "2022-06-20"


                                  <DetallesProduccion
                                    sProduccion={pProduccion}
                                    tipo={"todo"}
                                    bColor={"info floatrightleft "}
                                    btitle={"Detalle de producción"}
                                  />

                                )}
                              {(!pProduccion.terminado && ppcargaManual === true) &&
                                (((!pProduccion.piezasenPintado ? 0 : pProduccion.piezasenPintado) +
                                  (!pProduccion.piezasenCarga ? 0 : pProduccion.piezasenCarga) -
                                  (!pProduccion.piezasenPintado ? 0 : pProduccion.piezasenPintado)) < pProduccion.cantidadPlaneada) && ( // && Moment(now).format("YYYY-MM-DD") === "2022-06-20"
                                  <button
                                    className="cbutton btn-warning mt-1 mb-1 mr-2 "
                                    title="Carga sin QR"
                                    hidden={pProduccionPEyP.length ? false : true}
                                    onClick={() => {
                                      cargaSinQR(i);
                                    }}
                                  >
                                    <IoIcons.IoMdCloudUpload />
                                  </button>
                                )}
                              {(!pProduccion.terminado && ((!pProduccion.piezasenCarga ? -1 : pProduccion.piezasenCarga) > -1) &&
                                ((!pProduccion.piezasenPintado ? 0 : pProduccion.piezasenPintado) < pProduccion.cantidadPlaneada) &&
                                cargando === false) && (


                                  < Pintado
                                    sProduccion={pProduccion}
                                    bColor={pProduccion.piezasenPintado ===
                                      pProduccion.cantidadPiezas
                                      ? "cbutton bcolorbp mt-1 mb-1  floatrightleft"
                                      : "cbutton bcolorb mt-1 mb-1  floatrightleft"}
                                    btitle={"Marcar pintado"}
                                    modulo={"Producción"}
                                    usuario={userName}
                                    valorDeREtorno={handlePintado}
                                    proceso={"Ecoat"}
                                  />

                                )}
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                    <Modal isOpen={modal2} toggle={toggle2}>
                      <ModalHeader toggle={toggle2}>
                        Cargar material
                      </ModalHeader>
                      <ModalBody>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Cliente</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label>
                              {pProduccionPEyP[indexCarga].cliente}
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Número de parte</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label>
                              {pProduccionPEyP[indexCarga].numerodeParte}
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Descripción</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label>
                              {pProduccionPEyP[indexCarga].descripcion}
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Serial</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label>
                              {pProduccionPEyP[indexCarga].serial}
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Serial BTI</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label>
                              {pProduccionPEyP[indexCarga].serialRecibaBTI}
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Locación</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label>
                              {pProduccionPEyP[indexCarga].locacion}
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className={(!pProduccionPEyP[indexCarga].piezasenCargando) ? "tbold fcolorred" : "tbold"}>Cantidad*</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Input
                              name="piezasenCargando"
                              maxLength={20}
                              value={
                                pProduccionPEyP[indexCarga].piezasenCargando
                              }
                              onChange={(e) =>
                                setPProduccionPEyP(
                                  handleInputChangeCantidadCarga(
                                    e,
                                    indexCarga,
                                    [...pProduccionPEyP]
                                  )
                                )
                              }
                              placeholder=""
                            />
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Número de Rack</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Input
                              name="numeroRackCarga"
                              maxLength={20}
                              value={
                                pProduccionPEyP[indexCarga].numeroRackCarga
                              }
                              onChange={(e) =>
                                setPProduccionPEyP(
                                  handleInputChangeCantidadCarga(
                                    e,
                                    indexCarga,
                                    [...pProduccionPEyP]
                                  )
                                )
                              }
                              placeholder=""
                            />
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className={(!pProduccionPEyP[indexCarga].rackCarga) ? "tbold fcolorred" : "tbold"}>Racks*</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Input
                              name="rackCarga"
                              maxLength={20}
                              value={
                                pProduccionPEyP[indexCarga].rackCarga
                              }
                              onChange={(e) =>
                                setPProduccionPEyP(
                                  handleInputChangeCantidadCarga(
                                    e,
                                    indexCarga,
                                    [...pProduccionPEyP]
                                  )
                                )
                              }
                              placeholder=""
                            />
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Tipo de Rack</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <select
                              name="rackTipo"
                              className=" custom-select"
                              onChange={(e) =>
                                setPProduccionPEyP(
                                  handleInputChangeCantidadCarga(
                                    e,
                                    indexCarga,
                                    [...pProduccionPEyP]
                                  )
                                )
                              }
                            >
                              <option
                                value="" selected={!registroNuevoPP.rackTipo ? true : false}>
                              </option>
                              <option
                                value="Movible" selected={registroNuevoPP.rackTipo === "Movible" ? true : false}>Movible
                              </option>
                              <option
                                value="Fijo" selected={registroNuevoPP.rackTipo === "Fijo" ? true : false}>Fijo
                              </option>
                            </select>
                          </div>
                        </Row>
                        <Row>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <Label className="tbold">Ciclo</Label>
                          </div>
                          <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                            <select
                              name="cicloCarga"
                              className=" custom-select"
                              onChange={(e) =>
                                setPProduccionPEyP(
                                  handleInputChangeCantidadCarga(
                                    e,
                                    indexCarga,
                                    [...pProduccionPEyP]
                                  )
                                )
                              }
                            >
                              <option
                                value="1"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 1
                                    ? true
                                    : false
                                }
                              >
                                1
                              </option>
                              <option
                                value="2"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 2
                                    ? true
                                    : false
                                }
                              >
                                2
                              </option>
                              <option
                                value="3"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 3
                                    ? true
                                    : false
                                }
                              >
                                3
                              </option>
                              <option
                                value="4"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 4
                                    ? true
                                    : false
                                }
                              >
                                4
                              </option>
                              <option
                                value="5"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 5
                                    ? true
                                    : false
                                }
                              >
                                5
                              </option>
                              <option
                                value="6"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 6
                                    ? true
                                    : false
                                }
                              >
                                6
                              </option>
                              <option
                                value="7"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 7
                                    ? true
                                    : false
                                }
                              >
                                7
                              </option>
                              <option
                                value="8"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 8
                                    ? true
                                    : false
                                }
                              >
                                8
                              </option>
                              <option
                                value="9"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga === 9
                                    ? true
                                    : false
                                }
                              >
                                9
                              </option>
                              <option
                                value="10"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga ===
                                    10
                                    ? true
                                    : false
                                }
                              >
                                10
                              </option>
                              <option
                                value="11"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga ===
                                    11
                                    ? true
                                    : false
                                }
                              >
                                11
                              </option>
                              <option
                                value="12"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga ===
                                    12
                                    ? true
                                    : false
                                }
                              >
                                12
                              </option>
                              <option
                                value="13"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga ===
                                    13
                                    ? true
                                    : false
                                }
                              >
                                13
                              </option>
                              <option
                                value="14"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga ===
                                    14
                                    ? true
                                    : false
                                }
                              >
                                14
                              </option>
                              <option
                                value="15"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga ===
                                    15
                                    ? true
                                    : false
                                }
                              >
                                15
                              </option>
                              <option
                                value="16"
                                selected={
                                  pProduccionPEyP[indexCarga].cicloCarga ===
                                    16
                                    ? true
                                    : false
                                }
                              >
                                16
                              </option>
                            </select>
                          </div>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        {pProduccionPEyP[indexCarga]
                          .piezasenCargaDisponibles > 0 && (
                            <Button
                              color="primary"
                              onClick={() => aceptarCargar(indexCarga)}
                            >
                              Aceptar
                            </Button>
                          )}
                        <Button color="danger" onClick={toggle2}>
                          Cancelar
                        </Button>
                      </ModalFooter>
                    </Modal>
                    <Modal isOpen={modal3} toggle={toggle3} size="xl" >
                      <ModalHeader toggle={toggle3}>
                        Detalles de carga
                      </ModalHeader>
                      <ModalBody>
                        <Row>
                          <div className={detallesCarga.length > 20 ? " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll wrapper" :
                            " col-lg-12 col-md-12 col-sm-12 col-xs-12 scroll "}>
                            <Table className="mb-2 scroll ">
                              <Thead class="thead-secondary">
                                <Tr>
                                  <Th >No.</Th>
                                  <Th >Fecha</Th>
                                  <Th >Hora</Th>
                                  <Th >Cantidad</Th>
                                  <Th>Número de rack</Th>
                                  <Th>Racks </Th>
                                  <Th>Ciclos</Th>
                                  <Th >Usuario  </Th>
                                  <Th >Módulo </Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {detallesCarga.map((carga, i) => (
                                  //reciba.cantidadPlaneada < reciba.cantidadRecibida && (
                                  <Tr className={i % 2 !== 0 ? "table-active" : ""}>
                                    <Td>{i + 1}</Td>
                                    <Td className="margintopmobil20px">{carga.fecha}</Td>
                                    <Td className="margintopmobil20px">{carga.hora}</Td>
                                    <Td className="margintopmobil20px">{carga.piezasenCarga}</Td>
                                    <Td className="margintopmobil20px">{carga.numeroRackCarga}</Td>
                                    <Td className="margintopmobil20px">{carga.racks}</Td>
                                    <Td className="margintopmobil40px">{carga.ciclos} </Td>
                                    <Td className="margintopmobil40px">{carga.Reg_Ins_Usuario} </Td>
                                    <Td>{carga.modulo}</Td>
                                  </Tr>
                                  // )
                                ))}
                              </Tbody>
                            </Table>
                          </div>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                        <Button color="danger" onClick={toggle3}>
                          Cerrar
                        </Button>
                      </ModalFooter>
                    </Modal>
                  </div>
                </Row>
                <div class="col-lg-12 col-md-12 col-sm-12 mt-2 mb-1 ">
                  <h5 class="floatcenter">{sumProduccionp}</h5>
                </div>
              </>
            )}
            {guardando === false && (
              <BarcodeReader
                onError={handleError}
                onScan={handleScan}
                minLength={1}
              />
            )}
            <Modal isOpen={modal} toggle={toggle}>
              <ModalHeader toggle={toggle}>
                Material nuevo en el plan de producción
              </ModalHeader>
              <ModalBody>
                {guardando === true && (
                  <Row>
                    <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter"></div>
                    <p className="ml-2">Guardando datos, espere un momento por favor.</p>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 textaligmentcenter ">
                      <img class="floatcenter" width="150px" src="assets/img/preloader.gif" />
                    </div>
                  </Row>

                )}
                {guardando === false && (
                  <Fragment>
                    <Row>
                      <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 "></div>
                      <p className="ml-2">El material se agregará al plan de producción  del día de hoy {Moment(new Date()).format("DD-MM-YYYY")}, en caso de no existir plan de produccion, se creará.</p>
                    </Row>
                    <Row>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                        <Label className="tbold">Cliente: </Label> <Label>{registroNuevoPP.cliente} </Label>
                      </div>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                        <Label className="tbold">No. de parte: </Label> <Label>{registroNuevoPP.numerodeParte}</Label>
                      </div>
                    </Row>
                    <Row>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                        <Label className="tbold">Descripción: </Label> {registroNuevoPP.descripcion} <Label></Label>
                      </div>
                      {sporNPU === false && (
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <Label className="tbold">Serial: </Label> <Label>{registroNuevoPP.serial}</Label>
                        </div>
                      )}
                    </Row>
                    {sporNPU === false && (
                      <Row>
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <Label className="tbold">Serial BTI</Label>
                        </div>
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <Label>
                            {registroNuevoPP.serialRecibaBTI}
                          </Label>
                        </div>
                      </Row>
                    )}

                    {sporNPU === false && (
                      <Row>
                        <div className=" col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                          <p className="ml-2">Datos de carga</p>
                        </div>
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <Label className={(!registroNuevoPP.cantidadPiezasCargando || (registroNuevoPP.cantidadDisponible < registroNuevoPP.cantidadPiezasCargando)) ?
                            "tbold fcolorred" : "tbold"}>Cantidad*</Label>
                        </div>
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <Input
                            name="cantidadPiezasCargando"
                            value={
                              registroNuevoPP.cantidadPiezasCargando
                            }
                            onChange={(e) => handleInputChange(e)}
                            placeholder=""
                          />
                        </div>
                      </Row>
                    )}
                    <Row>
                      <div className={!registroNuevoPP.materialEnCantidad ? " fcolorred col-lg-6 col-md-6 col-sm-6 col-xs-6 " : "col-lg-6 col-md-6 col-sm-6 col-xs-6 "}>
                        <Label className="tbold">Empaques*</Label>
                      </div>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                        <Input name="materialEnCantidad" placeholder="" value={registroNuevoPP.materialEnCantidad} onChange={e => handleInputChange(e)} />
                      </div>
                    </Row>
                    <Row>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                        <Label className="tbold">Número de Rack</Label>
                      </div>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                        <Input
                          name="numeroRackCarga"
                          maxLength={20}
                          value={
                            registroNuevoPP.numeroRackCarga
                          }
                          onChange={(e) => handleInputChange(e)}
                          placeholder=""
                        />
                      </div>
                    </Row>
                    <Row>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                        <Label className="tbold">Tipo de Rack</Label>
                      </div>
                      <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                        <select
                          name="rackTipo"
                          className=" custom-select"
                          onChange={(e) => handleInputChange(e)}
                        >
                          <option
                            value="" selected={!registroNuevoPP.rackTipo ? true : false}>
                          </option>
                          <option
                            value="Movible" selected={registroNuevoPP.rackTipo === "Movible" ? true : false}>Movible
                          </option>
                          <option
                            value="Fijo" selected={registroNuevoPP.rackTipo === "Fijo" ? true : false}>Fijo
                          </option>
                        </select>
                      </div>
                    </Row>
                    {sporNPU === false && (
                      <Row>
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <Label className={(!registroNuevoPP.rackCarga) ? "tbold fcolorred" : "tbold"}>Racks*</Label>
                        </div>
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <Input
                            name="rackCarga"
                            maxLength={20}
                            value={registroNuevoPP.rackCarga}
                            onChange={(e) => handleInputChange(e)}
                            placeholder=""
                          />
                        </div>
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <Label className={(!registroNuevoPP.cicloCarga) ? "tbold fcolorred" : "tbold"}>Ciclo*</Label>
                        </div>
                        <div className=" col-lg-6 col-md-6 col-sm-6 col-xs-6 ">
                          <select
                            name="cicloCarga"
                            className=" custom-select"
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option
                              value="1"
                              selected={
                                registroNuevoPP.cicloCarga === 1
                                  ? true
                                  : false
                              }
                            >
                              1
                            </option>
                            <option
                              value="2"
                              selected={
                                registroNuevoPP.cicloCarga === 2
                                  ? true
                                  : false
                              }
                            >
                              2
                            </option>
                            <option
                              value="3"
                              selected={
                                registroNuevoPP.cicloCarga === 3
                                  ? true
                                  : false
                              }
                            >
                              3
                            </option>
                            <option
                              value="4"
                              selected={
                                registroNuevoPP.cicloCarga === 4
                                  ? true
                                  : false
                              }
                            >
                              4
                            </option>
                            <option
                              value="5"
                              selected={
                                registroNuevoPP.cicloCarga === 5
                                  ? true
                                  : false
                              }
                            >
                              5
                            </option>
                            <option
                              value="6"
                              selected={
                                registroNuevoPP.cicloCarga === 6
                                  ? true
                                  : false
                              }
                            >
                              6
                            </option>
                            <option
                              value="7"
                              selected={
                                registroNuevoPP.cicloCarga === 7
                                  ? true
                                  : false
                              }
                            >
                              7
                            </option>
                            <option
                              value="8"
                              selected={
                                registroNuevoPP.cicloCarga === 8
                                  ? true
                                  : false
                              }
                            >
                              8
                            </option>
                            <option
                              value="9"
                              selected={
                                registroNuevoPP.cicloCarga === 9
                                  ? true
                                  : false
                              }
                            >
                              9
                            </option>
                            <option
                              value="10"
                              selected={
                                registroNuevoPP.cicloCarga ===
                                  10
                                  ? true
                                  : false
                              }
                            >
                              10
                            </option>
                            <option
                              value="11"
                              selected={
                                registroNuevoPP.cicloCarga ===
                                  11
                                  ? true
                                  : false
                              }
                            >
                              11
                            </option>
                            <option
                              value="12"
                              selected={
                                registroNuevoPP.cicloCarga ===
                                  12
                                  ? true
                                  : false
                              }
                            >
                              12
                            </option>
                            <option
                              value="13"
                              selected={
                                registroNuevoPP.cicloCarga ===
                                  13
                                  ? true
                                  : false
                              }
                            >
                              13
                            </option>
                            <option
                              value="14"
                              selected={
                                registroNuevoPP.cicloCarga ===
                                  14
                                  ? true
                                  : false
                              }
                            >
                              14
                            </option>
                            <option
                              value="15"
                              selected={
                                registroNuevoPP.cicloCarga ===
                                  15
                                  ? true
                                  : false
                              }
                            >
                              15
                            </option>
                            <option
                              value="16"
                              selected={
                                registroNuevoPP.cicloCarga ===
                                  16
                                  ? true
                                  : false
                              }
                            >
                              16
                            </option>
                          </select>
                        </div>
                      </Row>
                    )}
                  </Fragment>
                )}
              </ModalBody>
              <ModalFooter>
                {guardando === false && (
                  <Fragment>
                    <Button
                      color="primary"
                      onClick={managePProduccion}
                    >
                      Aceptar
                    </Button>
                    <Button color="danger" onClick={toggle}>
                      Cancelar
                    </Button>
                  </Fragment>
                )}
                {/*<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(recibaSNP)}</div>*/}
              </ModalFooter>

            </Modal>

            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(pProduccionPEyP)}</div>*/}
            {/*<div className="col-lg-5 col-md-5 col-sm-12 col-xs-12 text-left scroll" style={{ marginTop: 20 }}>{JSON.stringify(Moment(now).format("YYY-MM-DD"))}</div>*/}
          </Fragment>
        </>
      )
      }
    </>
  );
}

export default Produccion;